import { Paper, type PaperProps, Suspense, styled } from '@lingoda/ui';
import { showErrorToast } from '@lingoda/toasts';
import { trans } from '@lingoda/i18n';
import { getApolloErrorUiMessage } from '@lingoda/monolith-graphql';
import { studentAchievementsPath } from '@lingoda/router';
import { SectionWrapper } from '../SectionWrapper';
import { useTopAchievements } from '../../hooks/useAchievements';
import { TopAchievementsLayout } from './TopAchievementsLayout';

interface TopAchievementsProps {
    isYearlyRecapVisible: boolean;
    paperProps?: PaperProps;
}

export const TopAchievements = ({ isYearlyRecapVisible, paperProps }: TopAchievementsProps) => {
    const { achievements, loading } = useTopAchievements({
        onError(error) {
            showErrorToast(getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'));
        },
        isYearlyRecapVisible,
    });

    if (!achievements.length && !isYearlyRecapVisible) {
        return null; // avoid rendering empty stack
    }
    const title = trans('achievements', {}, 'student-achievements');

    return (
        <PaperStyled {...paperProps}>
            <SectionWrapper
                title={title}
                titleProps={{ variant: 'h3' }}
                viewAllProps={{ href: studentAchievementsPath() }}
            >
                <Suspense variant="circular">
                    <TopAchievementsLayout
                        achievements={achievements}
                        loading={loading}
                        isYearlyRecapVisible={isYearlyRecapVisible}
                    />
                </Suspense>
            </SectionWrapper>
        </PaperStyled>
    );
};

const PaperStyled = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
}));
